class LogicalOperator {
    constructor(leftOperand, rightOperand) {
        this.leftOperand = leftOperand;
        this.rightOperand = rightOperand;
    }
}

// -------------------------------------------------------------------------------

class LogicalOperatorUnary {
    constructor(operand) {
        this.operand = operand;
    }
}

// -------------------------------------------------------------------------------

class LogicalNumberOperator {
    constructor(character, leftOperand, rightOperand) {
        this.leftOperand = leftOperand;
        this.rightOperand = rightOperand;
        this.character = character;
    }
    operate(left, right) {
        return 0;
    }
    evaluateNumber(solver) {
        return this.operate((this.leftOperand ? this.leftOperand.evaluateNumber(solver) : 0), (this.rightOperand ? this.rightOperand.evaluateNumber(solver) : 0));
    }
    solve(solver) {
        return this.evaluateNumber(solver);
    }
}



// -------------------------------------------------------------------------------

class LogicalNumberBooleanOperator {
    constructor(character, leftOperand, rightOperand) {
        this.leftOperand = leftOperand;
        this.rightOperand = rightOperand;
        this.character = character;
    }
    solve(solver) {
        return this.operate((this.leftOperand ? this.leftOperand.evaluateNumber(solver) : 0), (this.rightOperand ? this.rightOperand.evaluateNumber(solver) : 0));
    }
}


// ---- Logical (binary) operators ---------------------------------------------------------------------------
// and, or
export class LogicalAnd extends LogicalOperator {
    constructor(leftOperand, rightOperand) {
        super(leftOperand, rightOperand);
    }
    solve(solver) {
        return (this.leftOperand && this.leftOperand.solve(solver)) && (this.rightOperand && this.rightOperand.solve(solver));
    }
    toString() {
        return "(" + this.leftOperand.toString() + " & " + this.rightOperand.toString() + ")";
    }
    equals(le) {
        if (le instanceof LogicalAnd) {
            return this.leftOperand.equals(le.leftOperand) && this.rightOperand.equals(le.rightOperand);
        }
        return false;
    }
}




export class LogicalOr extends LogicalOperator {
    constructor(leftOperand, rightOperand) {
        super(leftOperand, rightOperand);
    }
    toString() {
        return "(" + this.leftOperand.toString() + " | " + this.rightOperand.toString() + ")";
    }
    equals(le) {
        if (le instanceof LogicalOr) {
            return this.leftOperand.equals(le.leftOperand) && this.rightOperand.equals(le.rightOperand);
        }
        return false;
    }
    solve(solver) {
        return (this.leftOperand && this.leftOperand.solve(solver)) || (this.rightOperand && this.rightOperand.solve(solver));
    }
}




// ---- Logical unary operators ---------------------------------------------------------------------------

export class LogicalNot extends LogicalOperatorUnary {
    constructor(operand) {
        super(operand);
    }
    toString() {
        return "!" + this.operand.toString();
    }
    equals(le) {
        if (le instanceof LogicalNot) {
            return this.operand.equals(le.operand);
        }
        return false;
    }
    solve(solver) {
        return !(this.operand && this.operand.solve(solver));
    }
}



// ---- LogicalNumber operators ---------------------------------------------------------------------------

export class LogicalAdd extends LogicalNumberOperator {
    constructor(leftOperand, rightOperand) {
        super("+", leftOperand, rightOperand);
    }
    toString() {
        return "(" + this.leftOperand.toString() + " + " + this.rightOperand.toString() + ")";
    }
    operate(left, right) {
        return +left + +right;
    }
    equals(le) {
        if (le instanceof LogicalAdd) {
            return this.leftOperand.equals(le.leftOperand) && this.rightOperand.equals(le.rightOperand);
        }
        return false;
    }
}



export class LogicalMultiply extends LogicalNumberOperator {
    constructor(leftOperand, rightOperand) {
        super("*", leftOperand, rightOperand);
    }
    toString() {
        return "(" + this.leftOperand.toString() + " * " + this.rightOperand.toString() + ")";
    }
    equals(le) {
        if (le instanceof LogicalMultiply) {
            return this.leftOperand.equals(le.leftOperand) && this.rightOperand.equals(le.rightOperand);
        }
        return false;
    }
    operate(left, right) {
        return left * right;
    }
}



// ---- LogicalNumberBoolean operators ---------------------------------------------------------------------------

export class LogicalBigger extends LogicalNumberOperator {
    constructor(leftOperand, rightOperand) {
        super(">", leftOperand, rightOperand);
    }
    toString() {
        return "(" + this.leftOperand.toString() + " > " + this.rightOperand.toString() + ")";
    }
    equals(le) {
        if (le instanceof LogicalBigger) {
            return this.leftOperand.equals(le.leftOperand) && this.rightOperand.equals(le.rightOperand);
        }
        return false;
    }
    operate(left, right) {
        return left > right;
    }
}


export class LogicalBiggerOrEquals extends LogicalNumberOperator {
    constructor(leftOperand, rightOperand) {
        super(">=", leftOperand, rightOperand);
    }
    toString() {
        return "(" + this.leftOperand.toString() + " >= " + this.rightOperand.toString() + ")";
    }
    equals(le) {
        if (le instanceof LogicalBiggerOrEquals) {
            return this.leftOperand.equals(le.leftOperand) && this.rightOperand.equals(le.rightOperand);
        }
        return false;
    }
    operate(left, right) {
        return left >= right;
    }
}




export class LogicalEquals extends LogicalNumberBooleanOperator {
    constructor(leftOperand, rightOperand) {
        super("==", leftOperand, rightOperand);
    }
    toString() {
        return "(" + this.leftOperand.toString() + " == " + this.rightOperand.toString() + ")";
    }
    equals(le) {
        if (le instanceof LogicalEquals) {
            return this.leftOperand.equals(le.leftOperand) && this.rightOperand.equals(le.rightOperand);
        }
        return false;
    }
    operate(left, right) {
        return left == right;
    }
}



export class LogicalSmaller extends LogicalNumberBooleanOperator {
    constructor(leftOperand, rightOperand) {
        super("<", leftOperand, rightOperand);
    }
    operate(left, right) {
        return left < right;
    }
    toString() {
        return "(" + this.leftOperand.toString() + " < " + this.rightOperand.toString() + ")";
    }
    equals(le) {
        if (le instanceof LogicalSmaller) {
            return this.leftOperand.equals(le.leftOperand) && this.rightOperand.equals(le.rightOperand);
        }
        return false;
    }
}



export class LogicalSmallerOrEquals extends LogicalNumberBooleanOperator {
    constructor(leftOperand, rightOperand) {
        super("<=", leftOperand, rightOperand);
    }
    toString() {
        return "(" + this.leftOperand.toString() + " <= " + this.rightOperand.toString() + ")";
    }
    equals(le) {
        if (le instanceof LogicalSmallerOrEquals) {
            return this.leftOperand.equals(le.leftOperand) && this.rightOperand.equals(le.rightOperand);
        }
        return false;
    }
    operate(left, right) {
        return left <= right;
    }
}




// ---- Logical elements ---------------------------------------------------------------------------
// number, booleans, variable
export class LogicalNumber {
    constructor(value) {
        this.name = null;
        this.value = value;
    }
    toString() {
        return "" + this.value;
    }
    equals(le) {
        if (le instanceof LogicalNumber) {
            return le.value === this.value;
        }
        return false;
    }
    evaluateNumber(solver) {
        return this.value;
    }
}




export class LogicalTrue {
    solve(solver) {
        return true;
    }
    toString() {
        return "true";
    }
    equals(le) {
        return le instanceof LogicalTrue;
    }
}




export class LogicalFalse {
    solve(solver) {
        return false;
    }
    toString() {
        return "false";
    }
    equals(le) {
        return le instanceof LogicalFalse;
    }
}




export class LogicalVariable {
    constructor(name) {
        this.name = null;

        if (LogicalVariable.isValidVariableName(name)) {
            this.name = name;
        } else {
            this.nameError(name);
        }
    }
    toString() {
        return this.name;
    }
    equals(le) {
        if (le instanceof LogicalVariable) {
            return le.name === this.name;
        }
        return this.name;
    }
    solve(solver) {
        return solver(this.name);
    }
    evaluateNumber(solver) {
        var result = solver(this.name);

        if (typeof result == "number" || (typeof result == "object" && result.constructor === Number)) {
            return result;
        } else {
            throw "<LogicalVariable>: variable '" + this.name + "' used as a Number but solver did not return a Number";
        }
    }
    static isValidVariableName(name) {
        var regExp = /^[a-zA-Z_#.@][a-zA-Z_0-9#.@]*$/;
        return regExp.test(name);
    }
}







